import React from 'react';
import MainTitle from 'base/components/MainTitle';
import Header from 'base/components/Header';

const Permissions = () => (
  <>
    <Header>
      <MainTitle>
        Permissions
        <br />
        Choose a role on the left.
      </MainTitle>
    </Header>
  </>
);

export default Permissions;
